// This script initializes the tab functionality for the main search page.
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize tabs
    const tabsNav = document.getElementById('tabs-nav');
    const tabLinks = tabsNav.querySelectorAll('a');
    const tabContents = document.querySelectorAll('.tab-content');

    // Show first tab by default
    document.querySelector('.tab-content').classList.add('active');

    // Handle tab clicks
    tabLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // Remove active classes
        tabLinks.forEach(link => link.parentElement.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Add active class to clicked tab
        link.parentElement.classList.add('active');

        const filterSorting = document.querySelector('.filter-sorting');
        if (filterSorting) {
          filterSorting.hidden = link.dataset.tab === 'articles';
        }
        // Show corresponding content
        const tabId = link.getAttribute('href');
        document.querySelector(tabId).classList.add('active');
      });
    });
  });